import { render, staticRenderFns } from "./PriceManage.vue?vue&type=template&id=26b371b7&scoped=true&"
import script from "./PriceManage.vue?vue&type=script&lang=js&"
export * from "./PriceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b371b7",
  null
  
)

export default component.exports